import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButtonsOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 .182a3.273 3.273 0 0 0-3.264 3.02l3.518 3.517a3.273 3.273 0 0 0 3.02-3.264A3.273 3.273 0 0 0 10 .182M1.58.58a1 1 0 0 0-.707.293 1 1 0 0 0 0 1.414l16.84 16.84a1 1 0 0 0 1.414 0 1 1 0 0 0 0-1.414L2.287.873A1 1 0 0 0 1.58.58m14.965 6.147a3.273 3.273 0 0 0-3.262 3.021l3.516 3.516A3.273 3.273 0 0 0 19.819 10a3.273 3.273 0 0 0-3.274-3.273m-13.344.01A3.273 3.273 0 0 0 .181 10a3.273 3.273 0 0 0 3.274 3.273 3.273 3.273 0 0 0 3.264-3.02zm6.547 6.546a3.273 3.273 0 0 0-3.022 3.262A3.273 3.273 0 0 0 10 19.818a3.273 3.273 0 0 0 3.264-3.02z" })
});
export default SvgButtonsOff;
